import { FC, useEffect, useState } from "react"
import { formatValueAsDate } from "../../../../../helpers/utils/DateUtils";
import { AssignToSection } from "../../../modal/AssignToSection";
import { shouldDisableUpdateTax } from "../../../../../helpers/utils/OrderDetailUtils";
import { hasPermission } from "../../../../../helpers/utils/AccessControlUtils";
import AddFollowUpForProduct from "../../../modal/AddFollowUpForProduct";
import AssignToForm from "../Modals/AssignToForm";
import ConfirmationModal from "../../../../../components/layout/modal/ConfirmationModal";
import TeamListModal from "../Modals/TeamListModal";
import { useUtilDataQuery } from "../../../../profile/profileApi";
import AccountStatementModal from "../../Modals/AccountStatementModal";
import {
    useLazyGetContactEmailQuery,
    useRefreshRollMutation
} from "../../../ordersApi";
import { useParams } from "react-router-dom";
import UpdateTaxModal from "../Modals/UpdateTaxModal";
import Button from "../../../../../components/common/form/Button";
import SendToVendorList from "../../Modals/SendToVendorList";
import { useLazyGetLinkedAccountsServiceQuery } from "../../../productsApi";

interface props {
    toggleAccountSection?: any,
    setToggleAccountSection?: any,
    curProduct?: any,
    formType?: any,
    editable?: any,
    productStatus?: any,
    productSchema?: any,
    taskList?: any
    moduleAvailableForCounty?: any,
    isSavedResult?: any,
    handleOrderResultSubmit?: any
    isPdfExist?: any,
    isValidDataForPdfGenerate?: any
    setIsValidDataForPdfGenerate?: any
    setAssignedTo?: any,
    setAssignedTeam?: any,
    setProductId?: any,
    showTeamListModal?: any,
    assignedTeam?: any,
    setShowTeamListModal?: any
    setShowTeamManagerModal?: any,
    isUserManager?: any,
    disable?: any,
    unAcknowledged?: any
    handleMarkAsComplete?: any,
    orderData?: any,
    setIsSendNotification?: any,
    setShowDeliveryConfirmation?: any,
    requiresQc: any,
    handleGeneratePdf?: any
    productId?: any,
    isHoa?: boolean,
    showAccount?: any,
    certificate?: any,
    propertyResultTaxList?: any,
    setPropertyResultTaxList?: any,
    taxCheckedList?: any,
    setTaxCheckedList?: any,
    orderResultData?: any,
    certificateOptions?: any,
    contactEmailsData?: any,
    deliveryEmail?: any,
    setIsSavedResult?: any,
    propertyHaveResult?: any,
    assignTo?: any,
    setProductStatus?: any,
    showTeamManagerModal?: any,
    generatePDfApi?: boolean
    saveOrderResultApi?: boolean
    markAsCompletedApi?: boolean
    primaryCollectorId?: any,
    updateAccountList?: any,
    handleGenerateCadPrintOutPdf?: any,
    generateCadPrintoutPDfApi?:any

}

const TopSection: FC<props> = ({
    toggleAccountSection,
    setToggleAccountSection,
    editable,
    isSavedResult,
    deliveryEmail,
    setIsSendNotification,
    setShowDeliveryConfirmation,
    orderData,
    productStatus,
    handleOrderResultSubmit,
    handleGeneratePdf,
    handleMarkAsComplete,
    formType,
    disable,
    propertyHaveResult = null,
    taskList,
    productId = null,
    requiresQc,
    isPdfExist,
    propertyResultTaxList = null,
    setPropertyResultTaxList = null,
    taxCheckedList = null,
    setTaxCheckedList = null,
    assignTo,
    setIsSavedResult = null,
    setProductStatus = null,
    isValidDataForPdfGenerate,
    moduleAvailableForCounty = null,
    certificate = null,
    unAcknowledged,
    isUserManager,
    setIsValidDataForPdfGenerate = null,
    orderResultData = null,
    curProduct,
    setAssignedTo,
    setAssignedTeam,
    setProductId,
    showTeamListModal,
    assignedTeam,
    setShowTeamListModal,
    setShowTeamManagerModal,
    showTeamManagerModal,
    certificateOptions = null,
    contactEmailsData,
    showAccount = null,
    productSchema = "DEFAULT",
    generatePDfApi = false,
    saveOrderResultApi = false,
    markAsCompletedApi = false,
    primaryCollectorId,
    updateAccountList,
    handleGenerateCadPrintOutPdf,
    generateCadPrintoutPDfApi

}) => {


    const { orderId } = useParams();
    const [showSendToVendor, setShowSendToVendor] = useState(false);
    const [showUpdateTaxModal, setShowUpdateTaxModal] = useState(false);
    const [showUpdateRollModal, setShowUpdateRollModal] = useState(false);
    const [reloadRollButton, setReloadRollButton] = useState(false);
    const [reloadTaxButton, setReloadTaxButton] = useState(false);
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);
    const [showAccountStatementModal, setShowAccountStatementModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [hitContactEmail, setHitContactEmail] = useState(false);
    const { data: utilData } = useUtilDataQuery("");
    const [refreshRollTrigger, { isLoading: isRefreshingRoll, data, error }] = useRefreshRollMutation();
    const [showAssignToModal, setShowAssignToModal] = useState(false);
    const [triggerGetContactEmail, contactEmailResponse] = useLazyGetContactEmailQuery();
    const [linkedAccountDataApi, { data: linkedAccounts, isSuccess, isFetching }] = useLazyGetLinkedAccountsServiceQuery();


    const getContactEmail = async (
        e: React.MouseEvent<HTMLButtonElement>,
        orderDTO: any
    ): Promise<void> => {
        e.preventDefault();
        setLoader(true);
        setHitContactEmail(true);

        try {
            await triggerGetContactEmail(orderDTO).unwrap();
        } catch (err: any) {
            console.log(err?.message || 'Failed to fetch contact email');
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (formType !== 'Tax' && taskList !== null && taskList.length > 0) {
            const temp: any = [];

            if (propertyHaveResult !== null) {
                propertyHaveResult.forEach((pl: any) => {
                    const hasActiveTask = taskList.some(
                        (tl: any) => tl.args.propertyId === pl.id && tl.status !== "CANCELED"
                    );
                    if (!hasActiveTask) {
                        temp.push(pl);
                    }
                });
            }
            setFilteredProperties(temp);
        } else {
            setFilteredProperties(propertyHaveResult ?? []);
        }
    }, [propertyHaveResult, formType, taskList]);

    useEffect(() => {

        let deliveryEmails: any = [];
        if (contactEmailResponse?.data && hitContactEmail) {
            contactEmailResponse?.data?.map((cu: any) => {
                deliveryEmails.push({
                    label: cu,
                    value: cu
                })
            })
            if (deliveryEmails.length === contactEmailResponse?.data?.length) {
                setShowDeliveryConfirmation(true);
            }
        }
    }, [contactEmailResponse]);

    const handleRefreshRollSubmit = async () => {
        setReloadRollButton(true);
        setShowUpdateRollModal(false);
        try {
            const response = await refreshRollTrigger(orderId).unwrap();
            if (response?.errorCode === 200) {
                setIsSavedResult(true);
                setProductStatus('SAVED');
            }
            else {
                const propertyId = certificate?.accounts?.filter((el: any) => el.original && el.propertyId)?.map((el: any) => el.propertyId);
                console.log(propertyId?.length > 0)
                if (propertyId?.length > 0) {
                    linkedAccountDataApi({ primaryCollectorId: primaryCollectorId, accountIds: propertyId });
                }
            }
        }

        finally {
            setReloadRollButton(false);
        }
    };

    useEffect(() => {
        if (isSuccess) {
            if (linkedAccounts?.length > 0) {
                updateAccountList(linkedAccounts);
            }
        }
    }, [linkedAccounts, isSuccess]);

    return (
        <>

            <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                <div className="col-span-1"><i className="fa fa-bars fa_hoa_bg" onClick={() => {
                    setToggleAccountSection(!toggleAccountSection);
                }} aria-hidden="true" /></div>
                <div className="col-span-11 pb-2 text-right flex items-right justify-end">
                    <div className="flex breadcrumb-data items-center">
                        <div className={"mr-3"}
                            title={curProduct?.followUpTypeDTO != null ? (curProduct?.followUpTypeDTO?.name + ' : ' + formatValueAsDate(curProduct?.followUp?.followUpAdded, "MM/DD/YY") + ' ' + curProduct?.followUp?.followUpMessage) : "Start Follow Up"}
                            onClick={(e) => {
                                setShowFollowUpModal(true)

                            }}>
                            <i className="fa fa-tag fa-2x text-text-2 cursor-pointer"
                                style={{ color: curProduct?.followUpTypeDTO != null ? curProduct?.followUpTypeDTO?.hexColor : '' }}
                            />
                        </div>

                        {formType === "HOA" &&
                            <div className={"mr-3"}
                                onClick={() => {
                                    if (editable === true && curProduct.assignedTo === utilData?.userName) {
                                        setShowAccountStatementModal(true)
                                    }
                                }}
                            >
                                <i className={editable === true && curProduct.assignedTo === utilData?.userName ? "cursor-pointer fa fa-2x fa-file-invoice text-highlight-1" : "fa fa-file-invoice fa-2x text-text-3 disableSelection cursor-pointer"} />
                            </div>
                        }

                        {formType === "HOA" && productStatus !== "DELIVERED" &&

                            <div
                            >
                                <button
                                    className={editable === true && filteredProperties.length > 0 ? "bg-highlight-1 pl-2 p-1 pr-2 rounded-[11px] text-text-0 text_color mr-1 ml-0 cursor" : "bg-text-3 pl-2 p-1 pr-2 rounded-[11px] text-text-0 text_color mr-1  ml-0"}
                                    onClick={(e) => {
                                        if (editable === true && filteredProperties.length > 0) {
                                            setShowSendToVendor(true)
                                        }
                                    }}
                                    disabled={!editable || filteredProperties.length <= 0}
                                >Send To Vendor
                                </button>
                            </div>

                        }

                        <AssignToSection
                            isUserManager={isUserManager}
                            setShowAssignToModal={setShowAssignToModal}
                            assignedTo={curProduct?.assignedTo}
                            setAssignedTo={setAssignedTo}
                            assignedTeam={curProduct?.targetTeamId}
                            setAssignedTeam={setAssignedTeam}
                            productId={curProduct?.id}
                            setProductId={setProductId}
                            setShowTeamListModal={setShowTeamListModal}
                            setShowTeamManagerModal={setShowTeamManagerModal}
                            isHoa={formType === "HOA"}
                        />

                        {productSchema === "DEFAULT" && formType === "Tax" &&
                            <div

                                title={"Load from Rolls"}>
                                <button
                                    className={editable === true ? "text-text-0 bg-[rgb(70,130,180)] border border-transparent rounded-[11px] m-[7px_4px] px-[14px] py-[5px] ml-0 cursor" : "text-text-0 border border-transparent rounded-[11px] m-[7px_4px] px-[14px] py-[5px] ml-0 bg-text-3 cursor"}
                                    onClick={(e) => {
                                        if (editable === true && !reloadRollButton) {
                                            setShowUpdateRollModal(true)
                                        }
                                    }}
                                    disabled={!editable || reloadRollButton}
                                >

                                    <i className={reloadRollButton ? "fas fa-sync fa-spin" : "fa fa-rotate-left"} />
                                    <i className="fa fa-database ml-2" />
                                </button>
                            </div>
                        }
                        {productSchema === "DEFAULT" && formType === "Tax" &&
                            <div
                                title={moduleAvailableForCounty === true ? "Update Taxes" : "Web module not available for this county"}>
                                <button
                                    className={(editable === true && !shouldDisableUpdateTax(taskList) && moduleAvailableForCounty === true) ? `text-text-0 bg-highlight-0 border border-transparent rounded-[11px] m-[7px_4px] px-[14px] py-[5px] ml-0 cursor` : `text-text-0 border border-transparent rounded-[11px] m-[7px_4px] px-[14px] py-[5px] ml-0 bg-text-3 cursor`}
                                    onClick={(e) => {
                                        if (editable === true && !reloadTaxButton && moduleAvailableForCounty === true) {
                                            setShowUpdateTaxModal(true)
                                        }
                                    }} disabled={shouldDisableUpdateTax(taskList)}>
                                    <i className={reloadTaxButton ? "fas fa-sync fa-spin" : "fa fa-rotate-left"} />
                                    <i className="fa fa-globe ml-2" />
                                </button>
                            </div>
                        }

                        {(isSavedResult === false) &&

                            <Button btnText={formType === "HOA" ? 'Save HOA' : "Save Tax"}
                                isLoading={saveOrderResultApi} isHoa={formType === "HOA"}
                                onClick={() => {
                                    if (editable === true) {
                                        handleOrderResultSubmit();
                                    }
                                }} type={"button"} isDisabled={!editable} />

                        }
                        {isSavedResult && (isPdfExist === true && (productStatus === "SAVED" || productStatus === "QC" || productStatus === "PENDING")) &&
                            <Button btnText={'Mark as Completed'}
                                className={"mr-1"}
                                isLoading={markAsCompletedApi}
                                isHoa={formType === "HOA"}
                                onClick={() => {
                                    if (editable === true && isValidDataForPdfGenerate === true && unAcknowledged.length === 0) {
                                        handleMarkAsComplete();
                                    }
                                }}
                                type={"button"}
                                isDisabled={!editable || unAcknowledged?.length !== 0 || !isValidDataForPdfGenerate} />
                        }
                        {isSavedResult && formType !== "HOA" &&
                            <Button btnText={'Generate CAD Printout'}
                                className={"mr-1"}
                                isLoading={generateCadPrintoutPDfApi}
                                onClick={() => {
                                    if (editable === true) {
                                        handleGenerateCadPrintOutPdf();
                                    }
                                }} type={"button"}
                                isDisabled={!editable} />
                        }
                        {isSavedResult && (productStatus === "SAVED" || productStatus === "QC" || productStatus === "PENDING") &&
                            <Button btnText={'Generate PDF'}
                                title={unAcknowledged?.length === 0 ? "" : "Unacknowledged QC Results"}
                                isLoading={generatePDfApi}
                                isHoa={formType === "HOA"}
                                onClick={() => {
                                    if (editable === true && unAcknowledged?.length === 0) {
                                        handleGeneratePdf();
                                    }
                                }} type={"button"}
                                isDisabled={!editable || unAcknowledged?.length !== 0} />
                        }



                        {isSavedResult && isPdfExist === true && (productStatus === "COMPLETED" || productStatus === "MARKED") && orderData?.data?.branchDTO && hasPermission(["FILEDELIVER-V"]) &&
                            <Button
                                btnText={requiresQc === true ? 'Verify and Deliver' : (orderData.data.branchDTO?.packagedDelivery === false ? "Deliver" : "Packaged Delivery")}
                                isLoading={contactEmailResponse.isLoading}
                                isHoa={formType === "HOA"}
                                onClick={(e: any) => {
                                    if (editable === true && unAcknowledged.length === 0) {
                                        e.preventDefault();
                                        setIsSendNotification(orderData?.data?.branchDTO?.emailNotificationMode !== 'OFF');
                                        getContactEmail(e, orderData?.data).then(r => {
                                        });
                                    }
                                }} type={"button"}
                                isDisabled={!editable || unAcknowledged?.length !== 0} />
                        }


                    </div>
                </div>
                {showFollowUpModal && <AddFollowUpForProduct show={showFollowUpModal}
                    setShow={setShowFollowUpModal}
                    isHoa={formType === "HOA"}
                    btnName={curProduct.followUp != null && curProduct.followUp.followUpTypeId != null && curProduct.followUp.followUpTypeId !== "" ? "Update" : "Add"}
                    currentProduct={curProduct}
                    orderId={orderData?.data?.id}

                />}
                {showAssignToModal &&
                    <AssignToForm show={showAssignToModal}
                        setShow={setShowAssignToModal}
                        productId={productId}
                        tenant={orderData?.data?.tenant}
                        isHoa={formType === "HOA"} />

                }
                {showTeamListModal && <TeamListModal
                    show={showTeamListModal}
                    setShow={setShowTeamListModal}
                    assignedToProps={assignedTeam}
                    productId={productId}
                    tenant={orderData?.data?.tenant}
                    isHoa={formType === "HOA"} />
                }

                {showUpdateRollModal && <ConfirmationModal title={"Refresh Order Results"}
                    bodyMessage={<><p>Reload order results from Rolls. Refreshing
                        order
                        results will delete existing order results data.</p>
                        <p>Continue ?</p></>}
                    onSubmit={handleRefreshRollSubmit}
                    show={showUpdateRollModal}
                    setShow={setShowUpdateRollModal}
                    isHoa={formType === "HOA"}
                    isLoading={isRefreshingRoll}
                />
                }
                {
                    showAccountStatementModal &&
                    <AccountStatementModal show={showAccountStatementModal} setShow={setShowAccountStatementModal}
                        certificate={certificate} showAccount={showAccount}
                        storageData={utilData} orderData={orderData} productId={productId} />
                }


                {
                    showUpdateTaxModal && <UpdateTaxModal show={showUpdateTaxModal} setShow={setShowUpdateTaxModal}
                        propertyResultTaxList={propertyResultTaxList}
                        setPropertyResultTaxList={setPropertyResultTaxList}
                        taxCheckedList={taxCheckedList}
                        setTaxCheckedList={setTaxCheckedList}
                        setReloadTaxButton={setReloadTaxButton}
                        certificate={certificate}
                        orderData={orderData}
                        productId={productId}
                        orderResultData={orderResultData}
                        setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                        certificateOptions={certificateOptions}
                    />

                }

                {showSendToVendor &&
                    <SendToVendorList show={showSendToVendor} setShow={setShowSendToVendor}
                        productId={productId} filteredProperties={filteredProperties}
                        setFilteredProperties={setFilteredProperties} />
                }

            </div>
        </>
    )
}
export default TopSection